var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: _vm.mergedClass, style: _vm.mergedStyle },
    [
      _vm.child
        ? _c(_vm.getComponentName(_vm.child.type), {
            ref: "element",
            tag: "Component",
            attrs: {
              elementPath: _vm.elementPath + ".0",
              configuration: _vm.child
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }